import type { IPushBridge } from './ports/IPushBridge'
import type { IPushDeviceGateway } from './ports/IPushDeviceGateway'

// Сценарий: продавец выходит — устройство выключается в notifire (пока токен сессии ещё действует),
// затем токен FCM удаляется в приложении: следующему продавцу на этом телефоне выдаётся новый.
export class LogoutPushDevice {
  constructor(
    private readonly bridge: IPushBridge,
    private readonly gateway: IPushDeviceGateway,
  ) {}

  async execute() {
    if (!this.bridge.isAvailable()) return

    try {
      const current = await this.bridge.currentToken()?.catch(() => null)
      if (current) await this.gateway.unregister(current.token)
    } finally {
      this.bridge.deleteToken()
    }
  }
}
